import { CapacityGranularity } from "@planzone/dto";
import { State } from "./types";

function matchRequest(
  req: State[number],
  resourceId: string,
  projectId: string,
  from: string,
  to: string,
  granularity: CapacityGranularity,
): boolean {
  return (
    req.adjustment.resourceId === resourceId &&
    req.adjustment.projectId === projectId &&
    req.adjustment.from === from &&
    req.adjustment.to === to &&
    req.adjustment.granularity === granularity
  );
}

export { matchRequest };
